import { Module } from 'vuex';
import { Route } from 'vue-router';
import Raven from 'frontend/utils/raven';

import {
  RootState,
  ClientType,
  PageHeaderContext,
  PremiumBannerVisiblityGetter,
  GlobalState,
} from 'frontend/types';

interface PageHeader {
  client_type?: ClientType;
  context?: PageHeaderContext;
}

interface ExtendedRootState extends RootState {
  globals: GlobalState;
}

const pageHeader: Module<PageHeader, ExtendedRootState> = {
  namespaced: true,
  state: () => ({
    client_type: undefined,
    context: undefined,
  }),
  mutations: {
    setValue(state, value: PageHeader): void {
      Object.assign(state, value);

      // Add client debug info for Sentry
      let client;
      if (state.client_type?.is_android) {
        client = 'android-native';
      } else if (state.client_type?.is_ios) {
        client = 'ios-native';
      } else if (state.client_type?.is_mobile) {
        client = 'mobile-browser';
      } else {
        client = 'desktop-browser';
      }
      Raven.setTagsContext({ client });
    },
  },
  getters: {
    clientType: state => state.client_type,
    isMobile:
      state =>
      ($mq: string): boolean => {
        // Alex 2/25/2020:
        // bypass Vue-mq on production for now to avoid issues when frontend and backend client types
        // are different and SSR is enabled
        // https://brilliant.slack.com/archives/C026AR1J7/p1581093744129300
        return (
          ($mq === 'mobile' && process.env.NODE_ENV === 'development') ||
          (state.client_type !== undefined && state.client_type.is_mobile)
        );
      },
    isNative: state => (state.client_type?.is_android || state.client_type?.is_ios) === true,
    messages: state => (state.context ? state.context.messages : null),
    coupon: state => (state.context ? state.context.coupon : null),

    canShowInitialReferralModal(
      state: PageHeader,
      _,
      rootState: ExtendedRootState,
    ): PremiumBannerVisiblityGetter {
      const user = rootState.globals?.user;
      return (route: Route) => {
        return (
          state.context !== undefined &&
          !!state.context.show_referral_modal &&
          route.meta.showReferralModal
        );
      };
    },
  },
};

export default pageHeader;
